exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "span.fUpfQ{cursor:pointer}span._1pYgD,span.fUpfQ{font-size:16px;margin:0 8px}._3jVVo{color:#777;font-style:italic}._2ylkQ{background:#8b0000;color:#fff;font-weight:700}._2ylkQ a{color:#fff!important;text-decoration:underline!important}.cwJm-{background:#f3d8d8;color:#8b0000}._3ATtt{background:#f9fad2}._1ecHX{background:#d2e7fa}._1oVlC{padding:0!important}.nBIga{padding:7px;line-height:24px}._3WKKh{padding:7px 3px;line-height:30px}.Y1dP1 div{overflow-x:hidden!important}.Y1dP1 div div div div{overflow:hidden!important}", ""]);

// exports
exports.locals = {
	"btn": "fUpfQ",
	"info": "_1pYgD",
	"sinSnapshot": "_3jVVo",
	"incumplimiento": "_2ylkQ",
	"facturaCancelada": "cwJm-",
	"conCambios": "_3ATtt",
	"conActualizaciones": "_1ecHX",
	"tdClear": "_1oVlC",
	"field": "nBIga",
	"fieldAsignacion": "_3WKKh",
	"hidden": "Y1dP1"
};